import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import type { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import type { DrawerContainer } from '../Drawer/DrawerContainer';
import { cart } from '../../theme/Cart';

import "./SideCart.scss";

@Component
export class SideCart extends ThemeComponent {
    @Prop({ default: 'side-cart' }) sectionId!: string;

    @Ref({ required: false }) updatingCart!: LoadingSpinner;

    private drawerContainer: DrawerContainer|null = null;

    private _onCartUpdate = new SimpleEvent<string>();
    public get onCartUpdate() {
        return this._onCartUpdate.asEvent();
    }

    init() {
        // Set the drawer container
        this.drawerContainer = this.closest('drawer-container');

        // Listen for cart item added
        this.listenForCartChanged();
    }

    public setLoading(loading: boolean = false) {
        if (loading) {
            this.updatingCart.classList.add('is-active');
        } else {
            this.updatingCart.classList.remove('is-active');
        }
    }    

    private listenForCartChanged() {
        this.$subscribe(cart.onChangeByInteraction, async() => {

            // Set loading
            this.setLoading(true);

            const url = new URL(window.location.href)
            url.searchParams.set('sections', 'side-cart');
            const res = await fetch(url).then(response => response.json());

            // Prepare correct markup
            const newSideCart = document.createElement('div');
            newSideCart.innerHTML = res['side-cart'];
            const newSideCartMain = newSideCart.querySelector('.side-cart__main');
            const currentSideCartMain = this.querySelector('.side-cart__main');

            if (newSideCartMain && currentSideCartMain) {
                currentSideCartMain.outerHTML = newSideCartMain.outerHTML;
            }

            this._onCartUpdate.dispatch('cart updated');

            this.handleLineItemQuantities();

            void this.handleSkinCareCollectionBanner();

            // Set loading
            this.setLoading(false);
        });
    }

    handleLineItemQuantities() {
        // eslint-disable-next-line
        const cartLineItems = document.querySelectorAll('cart-item');
        if (!cartLineItems) {return;}

        for (const cartItem of cart.items) {
            let totalQuantity = cartItem.quantity;

            // if subscription product we need to calculate the total quantity based on pack size
            if (cartItem.properties &&
                cartItem.properties['_shipping_interval_frequency'] &&
                cartItem.properties['_pack_size']
            ) {

                const packSize = Number(cartItem.properties['_pack_size']);
                totalQuantity = packSize > 1 ? Math.round(cartItem.quantity / packSize) : cartItem.quantity;

                const quantityUpdate =
                    document.querySelector(`.cart-row[data-id="${cartItem.id}"] .quantity-amount`);
                if (quantityUpdate) {
                    quantityUpdate.textContent = totalQuantity.toString();
                }
            }
        }
    }

    private async handleSkinCareCollectionBanner() {
        const isAbsoluter = this.drawerContainer?.querySelector(
            '.side-cart__main'
        )?.getAttribute('data-absoluter') === 'true';

        // If absoluter is false then reset banner messaging
        if (!isAbsoluter && window.location.href.includes('/deep-lift-skincare')) {
            const absoluterBanner = document.querySelector('.absoluter-global__media');
            const nonAbsoluterBanner = document.querySelector('.non-absoluter-global__media');

            if (absoluterBanner && nonAbsoluterBanner) {
                const addRemoveClass = (showAbsoluter: boolean) => {
                    absoluterBanner.classList.toggle('show', showAbsoluter);
                    nonAbsoluterBanner.classList.toggle('show', !showAbsoluter);
                };

                addRemoveClass(isAbsoluter);
            }
        }
    }

    public open() {
        this.classList.add('is-active');
    }

    public close() {
        this.classList.remove('is-active');
    }
}
